module.exports = __webpack_public_path__ + "static/pew-f3fb28340b10c9e79af8f54cd83275b8.png";